import api from '@/lib/api'

// =========================================================================
// Types
// =========================================================================

export interface AffiliateRecord {
    id: string
    name: string
    email: string
    trackingId: string | null
    referredCount: number
    convertedCount: number
    mrrContribution: number
    conversionRate: number
}

export interface AffiliateReferral {
    agencyId: string
    agencyName: string
    ownerName: string
    ownerEmail: string
    status: string | null
    planName: string | null
    signedUpAt: string
}

export interface AffiliateDetailRecord extends AffiliateRecord {
    referrals: AffiliateReferral[]
}

export interface AffiliatesPage {
    affiliates: AffiliateRecord[]
    page: number
    total: number
    totalPages: number
}

// =========================================================================
// Service
// =========================================================================

export const AffiliatesService = {
    getAll: async (
        page = 1,
        limit = 20,
        search = '',
        sort?: 'referred_desc' | 'referred_asc'
    ): Promise<AffiliatesPage> => {
        const params: Record<string, string | number> = { page, limit }
        if (search) params.search = search
        if (sort) params.sort = sort
        const response = await api.get('/admin/affiliates', { params })
        return response.data.data as AffiliatesPage
    },

    getById: async (id: string): Promise<AffiliateDetailRecord> => {
        const response = await api.get(`/admin/affiliates/${id}`)
        return response.data.data as AffiliateDetailRecord
    },

    addReferral: async (
        affiliateId: string,
        email: string
    ): Promise<{ referralId: string; agencyId: string; stripeUpdated: boolean }> => {
        const response = await api.post(`/admin/affiliates/${affiliateId}/referrals`, { email })
        return response.data.data
    },

    attributeAgency: async (
        affiliateId: string,
        agencyId: string
    ): Promise<{ referralId: string; agencyId: string; stripeUpdated: boolean }> => {
        const response = await api.post(`/admin/affiliates/${affiliateId}/referrals`, { agencyId })
        return response.data.data
    },
}
